import { FC } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import HorizontalTabs from 'components/HorizontalTabs';

const ManageInvites: FC = () => {
  const { syndicateId, dealId } = useParams<{ syndicateId: string; dealId: string }>() as {
    syndicateId: string;
    dealId: string;
  };

  const tabs = [
    {
      key: 'active',
      label: 'Invited',
      description: 'View and manage invited LPs',
      route: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites`,
      exact: true,
    },
    {
      key: 'passed',
      label: 'Passed',
      description: 'View and manage passed LPs',
      route: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites/passed`,
    },
    {
      key: 'viewed',
      label: 'Viewed',
      description: 'View and manage viewed LPs',
      route: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites/viewed`,
    },
    {
      key: 'cancelled',
      label: 'Cancelled',
      description: 'View and manage cancelled LPs',
      route: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites/cancelled`,
    },
    {
      key: 'blocked',
      label: 'Blocked',
      description: 'View and manage blocked LPs',
      route: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites/blocked`,
    },
  ];

  return (
    <>
      <div className="sm:flex sm:items-center sm:justify-between mb-3">
        <div className="max-w-xl">
          <h3 className="text-lg font-semibold leading-6 text-gray-700">Manage your invites</h3>
          <p className="mt-1 text-md text-gray-500">View details about your past invites.</p>
        </div>
      </div>

      <div className="mb-5">
        <HorizontalTabs tabs={tabs} renderSecondaryColours={true} />
      </div>

      <Outlet />
    </>
  );
};

export default ManageInvites;
